import type {
  IntegrationCall,
  IntegrationCallStatus,
  IntegrationCallSubjectType,
} from '@/shared/api/resources';

/**
 * Rotulos do registro de integracoes, comuns a aba Registro de /integracoes e a
 * tela de consultas a bureau.
 */

export const rotulosDaSituacao: Record<
  IntegrationCallStatus,
  { label: string; tone: 'success' | 'warning' | 'danger' | 'info' }
> = {
  sucesso: { label: 'Sucesso', tone: 'success' },
  parcial: { label: 'Parcial', tone: 'info' },
  falhou: { label: 'Falhou', tone: 'danger' },
  incerta: { label: 'Incerta', tone: 'warning' },
};

export const opcoesDaSituacao = (
  Object.keys(rotulosDaSituacao) as IntegrationCallStatus[]
).map((valor) => ({ value: valor, label: rotulosDaSituacao[valor].label }));

const rotulosDoObjeto: Record<IntegrationCallSubjectType, string> = {
  tomador: 'Tomador',
  corretor: 'Corretor',
  segurado: 'Segurado',
  operacao: 'Operacao',
  apolice: 'Apolice',
  endosso: 'Endosso',
  integracao: 'Provedor',
};

/**
 * "Identificacao da integracao" do OnPoint: de quem ou do que a chamada trata, e o
 * identificador dela no fornecedor.
 */
export function identificacao(call: IntegrationCall): string {
  const partes: string[] = [];
  if (call.subject) {
    partes.push(call.subject.label || rotulosDoObjeto[call.subject.type]);
  }
  if (call.external_reference) partes.push(call.external_reference);
  return partes.length > 0 ? partes.join(' · ') : 'Sem identificacao';
}
